import { useEffect } from 'react';
import { startGoogleOneTapPositionSync } from '../utils/googleOneTapPosition';

/**
 * Keeps Google's mobile One Tap sheet above the browser chrome.
 * GIS pins `#credential_picker_container` to `bottom: 0` of the layout
 * viewport, which iOS Safari overlays with its toolbar.
 */
export default function useGoogleOneTapSafePosition() {
  useEffect(() => startGoogleOneTapPositionSync(), []);
}
